module.exports = __webpack_public_path__ + "img/login-bg.608870cb.png";